export enum ClaimStatus {
  Open = 'Open',
  Closed = 'Closed',
  All = 'All',
}